import { Card, FormattedMessageDiv, FormattedNumberDiv, Tooltip } from "@odmonorepo/core-components"
import { Stack } from "react-bootstrap"
import { FormattedMessage, useIntl } from "react-intl"

export const TLCostAndFees = ({offer, ppdValue}) => {
    const intl = useIntl();

    return ( 
    <Card className="bg-light-gray shadow-none" bodyClassName="p-md-5 px-md-6 p-4">
      <Stack gap={3}>
      <FormattedMessageDiv
        className="fw-bold text-start"
        id="offerPreview.costAndFees"
      />
      <Stack direction="horizontal" className="text-start align-items-end">
        <div>
          <FormattedMessage id={`offerPreview.totalCost`} />
          <Tooltip
            title={intl.formatMessage({
            id: 'totalCostOfCapital.tooltip',
            })}
          />
        </div>
        <FormattedNumberDiv
        value={offer.pricedDetails.totalLoanCost}
        className="ms-auto"
        style="currency"
        currency="USD"
        />
      </Stack>
      <Stack direction="horizontal" className="text-start align-items-end">
        <div>
          <FormattedMessage
            id={`totalPaymentAmount.label`}
            values={{
            break: (
              <span className="d-inline d-md-none">
              <br />
              </span>
            ),
            }}
          />
          <Tooltip
            title={intl.formatMessage({
            id: `prepayment.tooltip.ppd.${ppdValue}`,
            })}
          />
        </div>
        <FormattedNumberDiv
        value={offer.pricedDetails.totalAmountPaidBack}
        className="ms-auto"
        style="currency"
        currency="USD"
        />
      </Stack>
      <Stack direction="horizontal" className="text-start align-items-end">
        <FormattedMessage id={'offerReview.returnedPaymentFee'} />
        <FormattedNumberDiv
        value={offer.returnedPaymentFee}
        className="ms-auto"
        style="currency"
        currency="USD"
        />
      </Stack>
      <Stack direction="horizontal" className="text-start">
        <FormattedMessage id={'offerReview.lateFee'} />
        <FormattedNumberDiv
        value={offer.lateFee}
        className="ms-auto"
        style="currency"
        currency="USD"
        />
      </Stack>
      </Stack>
    </Card>
        )}